<template>
    <div class="hyperlink">
        <div class="two-sided">
            <div class="form-field left">
                <div class="title">URL</div>
                <div class="value">
                    <InputUrl ref="url" v-model="url" class="text" />
                </div>
            </div>
            <div class="form-field right">
                <div class="title">Название ссылки</div>
                <div class="value">
                    <input v-model="title" type="text">
                </div>
            </div>
        </div>
        <input class="action primary" type="button" value="Вставить" @click="insertLink" />
        <input class="action" type="button" value="Отмена" @click="close" />
    </div>
</template>

<script>
import emitter from '@/common/comp/wysiwyg/bus.js';


export default {
    title: 'link',
    icon: 'Link',
    description: 'Hyperlink',
    props: {
        uid: null,
    },
    data() {
        return {
            url: '',
            title: '',
        };
    },
    mounted() {
        this.title = emitter.utils.getSelectedText();
        this.url = emitter.utils.getLinkHref();
        this.$refs.url.$el.focus();
    },
    methods: {
        insertLink() {
            if (!this.url) {
                this.close();
                return;
            }

            const url = `<a href="${ this.url }">${ this.title }</a>`;
            this.$emit('exec', 'unlink', null, false);
            this.$emit('exec', 'insertHTML', url);

            this.url = '';
            this.title = '';
        },
        close() {
            this.$emit('close');
            this.url = '';
            this.title = '';
        },
    },
};
</script>

<style lang="scss" scoped>
.hyperlink {
    .two-sided {
        gap: 8px;
    }

    .form-field {
        --form-field-margin: 0;
    }

    .action {
        margin-top: 8px;

        & + .action {
            margin-left: 8px;
        }
    }
}
</style>
